import React, { useState } from 'react'
import { Input, Row, Form, Col, notification, Button } from 'antd';
import { useMediaQuery } from 'react-responsive'
import { PlusOutlined } from '@ant-design/icons';
import RequestHandler from '../../util/RequestHandler';

const layout = {
  labelCol: {
    span: 10,
  },
  wrapperCol: {
    span: 11,
  },
};
const tailLayout = {
  wrapperCol: {
    offset: 8,
    span: 16,
  },
};

const ManualTransactionTypeAdd = () => {
  const isDesktopOrLaptop = useMediaQuery({ query: '(min-device-width: 1224px)' });
  const isTabletOrMobileDevice = useMediaQuery({ query: '(max-device-width: 1224px)' });

  const [loading, setLoading] = useState(false);
  const [name, setName] = useState('');

  const onChange = (e) => {
    setName(e.target.value)
  }

  const openNotificationWithIcon = type => {
    notification[type]({
      message: 'BAŞARILI',
      description:
        'Ekleme işlemi başarı ile gerçekleşti.',
      duration: 2,
    });
  };

  const onFinish = values => {
    RequestHandler.post(`/ManualTransactionType`, { name: values.Name }, false, { rawResponse: true }).then(res => {
      if (res.status == 200) {
        openNotificationWithIcon('success');
        setTimeout(function () {
          window.location.reload();
        }.bind(this), 2000);
      }else{
        setLoading(false)
        }
    });
  };

  const onFinishFailed = () => setLoading(false);

  return (
    <div>
      <Form
        {...layout}
        name="basic"
        initialValues={{
          remember: true,
        }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
      >
        <Row>
          {isDesktopOrLaptop && <>
            <Col span={24}>
              <Form.Item
                label="Tip Adı"
                style={{ marginTop: "4%" }}
                name="Name"
                rules={[
                  {
                    required: true,
                    message: 'Lütfen Tip Adı alanını boş bırakmayın.',
                  },
                ]}
              >
                <Input value={name} onChange={onChange} />
              </Form.Item>

            </Col>
            <Col span={6}></Col>
            <Col span={6}></Col>
            <Col span={6}></Col>
            <Col span={6}>
              <Form.Item {...tailLayout} >
                <Button type="primary" icon={<PlusOutlined />} htmlType="submit" onClick={() => setLoading(true)} loading={loading}>
                  Ekle
                </Button>
              </Form.Item>
            </Col>
          </>}
          {isTabletOrMobileDevice && <>
            <Col span={24}>
              <Form.Item
                label="Tip Adı"
                style={{ marginTop: "4%" }}
                name="Name"
                rules={[
                  {
                    required: true,
                    message: 'Lütfen Tip Adı alanını boş bırakmayın.',
                  },
                ]}
              >
                <Input value={name} onChange={onChange} />
              </Form.Item>

            </Col>
            <Col span={12}></Col>
            <Col span={6}>
              <Form.Item {...tailLayout} >
                <Button type="primary" icon={<PlusOutlined />} htmlType="submit" onClick={() => setLoading(true)} loading={loading}>
                  Ekle
                </Button>
              </Form.Item>
            </Col>

            <Col span={6}></Col>
          </>}

        </Row>
      </Form>
    </div>
  )
}

export default ManualTransactionTypeAdd